module.exports = __webpack_public_path__ + "static/media/vidal.823c27ed.png";